import type { ComponentType, MouseEvent } from 'react'
import { KIND, SHAPE } from 'baseui/button'
import type { ButtonOverrides } from 'baseui/button'
import { StatefulTooltip } from 'baseui/tooltip'
import BaseSDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import type { pulseTooltipOverrides } from '@/shared/components/PulseScope/styled-components'
import type { SDIconProps } from '@/shared/icons/SDIcon'

const SDButton = BaseSDButton as ComponentType<any>

interface IconActionButtonProps {
  label: string
  Icon: ComponentType<SDIconProps>
  onClick: (event: MouseEvent) => void
  overrides: ButtonOverrides
  tooltipOverrides: typeof pulseTooltipOverrides
  hidden?: boolean
}

const IconActionButton = ({
  label,
  Icon,
  onClick,
  overrides,
  tooltipOverrides,
  hidden = false,
}: IconActionButtonProps) => {
  if (hidden) return null

  return (
    <StatefulTooltip content={label} overrides={tooltipOverrides} placement='top' showArrow>
      <SDButton kind={KIND.secondary} shape={SHAPE.square} onClick={onClick} overrides={overrides} aria-label={label}>
        <Icon />
      </SDButton>
    </StatefulTooltip>
  )
}

export default IconActionButton
